// 订单管理模块多语言配置
export const order = {
  'zh-CN': {
    orderList: '订单列表',
    afterSale: '退款/售后',
    orderNumber: '订单号',
    orderStatus: '订单状态',
    orderType: '订单类型',
    orderAmount: '订单金额',
    resaleOrder: '进货订单',
    orderDate: '订单日期',
    deliveryTime: '发货时间',
    customerName: '客户姓名',
    receiveName: '收货人',
    customerPhone: '客户电话',
    receivePhone: '收货电话',
    productName: '商品名称',
    productPrice: '商品价格',
    productQuantity: '商品数量',
    productSpec: '产品规格',
    purchaseInfo: '购买情况',
    orderSource: '订单来源',
    personalOrder: '个人线下订单',
    totalAmount: '总金额',
    paymentMethod: '支付方式',
    deliveryAddress: '收货地址',
    addOrder: '添加订单',
    editOrder: '编辑订单',
    deleteOrder: '删除订单',
    searchOrder: '搜索订单',
    exportOrder: '导出订单',
    importOrder: '导入订单',
    // 订单状态
    allOrders: '全部订单',
    refunded: '已退款',
    expired: '已失效',
    refunding: '退款中',

    pendingPayment: '待付款',
    pendingShipment: '待发货',
    pendingReceipt: '待收货',
    completed: '已完成',
    transactionCancelled: '交易取消',
    refundSuccessful: '退款成功',

    // 退款售后
    refundReason: '退款原因',
    refundAmount: '退款金额',
    refundStatus: '退款状态',
    refundDate: '退款日期',
    afterSaleType: '售后类型',
    afterSaleStatus: '售后状态',
    afterSaleReason: '售后原因',
    // 订单类型
    distributionOrder: '分销订单',
    normalOrder: '普通订单',
    groupBuyOrder: '拼团订单',
    // 退款售后相关
    orderTime: '下单时间',
    selectDate: '选择日期',
    userPhone: '收货人电话',
    orderQuantity: '订单数量',
    cancelOrder: '撤销订单',
    confirmShipment: '确认发货',
    rejectRefund: '拒绝退款',
    confirmRefund: '确定退款',
    deleteOrderConfirm: '确定要删除这个订单吗？',
    cancelOrderConfirm: '确定要撤销该订单吗？',
    confirmShipmentConfirm: '是否确定发货？',
    rejectRefundConfirm: '是否拒绝退款？',
    confirmRefundConfirm: '是否确定退款',
    operationSuccess: '操作成功',
    refundOperationFailed: '退款操作失败',
    viewDetails: '查看详情',
    hideDetails: '隐藏详情',
    parentOrderDetails: '进货详情',
    noParentOrder: '未找到上级订单',
    getParentOrderFailed: '获取上级订单失败'
  },
  'zh-TW': {
    orderList: '訂單列表',
    afterSale: '退款/售後',
    orderNumber: '訂單號',
    orderStatus: '訂單狀態',
    orderType: '訂單類型',
    orderAmount: '訂單金額',
    resaleOrder: '進貨訂單',
    orderDate: '訂單日期',
    deliveryTime: '發貨時間',
    customerName: '客戶姓名',
    receiveName: '收貨人',
    customerPhone: '客戶電話',
    receivePhone: '收貨電話',
    productName: '商品名稱',
    productPrice: '商品價格',
    productQuantity: '商品數量',
    productSpec: '產品規格',
    purchaseInfo: '購買情況',
    orderSource: '訂單來源',
    personalOrder: '個人線下訂單',
    totalAmount: '總金額',
    paymentMethod: '支付方式',
    deliveryAddress: '收貨地址',
    addOrder: '添加訂單',
    editOrder: '編輯訂單',
    deleteOrder: '刪除訂單',
    searchOrder: '搜索訂單',
    exportOrder: '導出訂單',
    importOrder: '導入訂單',
    // 訂單狀態
    allOrders: '全部訂單',
    refunded: '已退款',
    expired: '已失效',
    refunding: '退款中',

    pendingPayment: '待付款',
    pendingShipment: '待發貨',
    pendingReceipt: '待收貨',
    completed: '已完成',
    transactionCancelled: '交易取消',
    refundSuccessful: '退款成功',

    // 退款售後
    refundReason: '退款原因',
    refundAmount: '退款金額',
    refundStatus: '退款狀態',
    refundDate: '退款日期',
    afterSaleType: '售後類型',
    afterSaleStatus: '售後狀態',
    afterSaleReason: '售後原因',
    // 訂單類型
    distributionOrder: '分銷訂單',
    normalOrder: '普通訂單',
    groupBuyOrder: '拼團訂單',
    // 退款售後相關
    orderTime: '下單時間',
    selectDate: '選擇日期',
    userPhone: '收貨人電話',
    orderQuantity: '訂單數量',
    cancelOrder: '撤銷訂單',
    confirmShipment: '確認發貨',
    rejectRefund: '拒絕退款',
    confirmRefund: '確定退款',
    deleteOrderConfirm: '確定要刪除這個訂單嗎？',
    cancelOrderConfirm: '確定要撤銷該訂單嗎？',
    confirmShipmentConfirm: '是否確定發貨？',
    rejectRefundConfirm: '是否拒絕退款？',
    confirmRefundConfirm: '是否確定退款',
    operationSuccess: '操作成功',
    refundOperationFailed: '退款操作失敗',
    viewDetails: '查看詳情',
    hideDetails: '隱藏詳情',
    parentOrderDetails: '進貨詳情',
    noParentOrder: '未找到上級訂單',
    getParentOrderFailed: '獲取上級訂單失敗'
  },
  'en': {
    orderList: 'Order List',
    afterSale: 'Refund/After-Sale',
    orderNumber: 'Order Number',
    orderStatus: 'Order Status',
    orderType: 'Order Type',
    orderAmount: 'Order Amount',
    resaleOrder: 'Purchase Order',
    orderDate: 'Order Date',
    deliveryTime: 'Delivery Time',
    customerName: 'Customer Name',
    receiveName: 'Recipient Name',
    customerPhone: 'Customer Phone',
    receivePhone: 'Recipient Phone',
    productName: 'Product Name',
    productPrice: 'Product Price',
    productQuantity: 'Product Quantity',
    productSpec: 'Product Spec',
    purchaseInfo: 'Purchase Info',
    orderSource: 'Order Source',
    personalOrder: 'Personal Offline Order',
    totalAmount: 'Total Amount',
    paymentMethod: 'Payment Method',
    deliveryAddress: 'Delivery Address',
    addOrder: 'Add Order',
    editOrder: 'Edit Order',
    deleteOrder: 'Delete Order',
    searchOrder: 'Search Order',
    exportOrder: 'Export Order',
    importOrder: 'Import Order',
    // Order status
    allOrders: 'All Orders',
    refunded: 'Refunded',
    expired: 'Expired',
    refunding: 'Refunding',

    pendingPayment: 'Pending Payment',
    pendingShipment: 'Pending Shipment',
    pendingReceipt: 'Pending Receipt / Shipped',
    completed: 'Completed',
    transactionCancelled: 'Transaction Cancelled',
    refundSuccessful: 'Refund Successful',

    // Refund after-sale
    refundReason: 'Refund Reason',
    refundAmount: 'Refund Amount',
    refundStatus: 'Refund Status',
    refundDate: 'Refund Date',
    afterSaleType: 'After-Sale Type',
    afterSaleStatus: 'After-Sale Status',
    afterSaleReason: 'After-Sale Reason',
    // Order types
    distributionOrder: 'Distribution Orders',
    normalOrder: 'Normal Orders',
    groupBuyOrder: 'Group Buy Orders',
    // After-sale related
    orderTime: 'Order Time',
    selectDate: 'Select Date',
    userPhone: 'Recipient Phone',
    orderQuantity: 'Order Quantity',
    cancelOrder: 'Cancel Order',
    confirmShipment: 'Confirm Shipment',
    rejectRefund: 'Reject Refund',
    confirmRefund: 'Confirm Refund',
    deleteOrderConfirm: 'Are you sure you want to delete this order?',
    cancelOrderConfirm: 'Are you sure you want to cancel this order?',
    confirmShipmentConfirm: 'Are you sure you want to ship?',
    rejectRefundConfirm: 'Do you want to reject the refund?',
    confirmRefundConfirm: 'Are you sure you want to refund?',
    operationSuccess: 'Operation Successful',
    refundOperationFailed: 'Refund Operation Failed',
    viewDetails: 'View Details',
    hideDetails: 'Hide Details',
    parentOrderDetails: 'Purchase Details',
    noParentOrder: 'No parent order found',
    getParentOrderFailed: 'Failed to get parent order'
  }
}; 